import styled from "styled-components";
import { Field as FField } from "formik";

export const Field = styled(FField)`
  appearance: none;
  background: var(--white);
  border: 1px solid var(--silver);
  border-radius: 0;
  box-shadow: inset 0 1px 2px var(--gallery);
  font-size: 12px;
  padding: 3px;
  width: 100%;

  &:focus {
    border: 1px solid var(--dusty-gray);
  }
`;
